import { z } from 'zod';
export var AgentControllerType;
(function (AgentControllerType) {
    AgentControllerType["User"] = "user";
    AgentControllerType["Organization"] = "organization";
})(AgentControllerType || (AgentControllerType = {}));
export var AgentCredentialStatus;
(function (AgentCredentialStatus) {
    AgentCredentialStatus["Pending"] = "pending";
    AgentCredentialStatus["Active"] = "active";
    AgentCredentialStatus["Revoked"] = "revoked";
})(AgentCredentialStatus || (AgentCredentialStatus = {}));
export var AgentChallengePurpose;
(function (AgentChallengePurpose) {
    AgentChallengePurpose["Registration"] = "registration";
    AgentChallengePurpose["Authentication"] = "authentication";
    AgentChallengePurpose["KeyRotation"] = "key_rotation";
})(AgentChallengePurpose || (AgentChallengePurpose = {}));
export var AgentServiceGrantStatus;
(function (AgentServiceGrantStatus) {
    AgentServiceGrantStatus["Pending"] = "pending";
    AgentServiceGrantStatus["Approved"] = "approved";
    AgentServiceGrantStatus["Revoked"] = "revoked";
})(AgentServiceGrantStatus || (AgentServiceGrantStatus = {}));
export const agentControllerTypeGuard = z.nativeEnum(AgentControllerType);
export const agentCredentialStatusGuard = z.nativeEnum(AgentCredentialStatus);
export const agentChallengePurposeGuard = z.nativeEnum(AgentChallengePurpose);
export const agentServiceGrantStatusGuard = z.nativeEnum(AgentServiceGrantStatus);
export const agentScopesGuard = z.array(z.string().min(1).max(128)).max(64);
